(function () {

  'use strict';

  angular.module('PrintixInfoUser', [])

    .constant('PrintixUserInfoConstants', {
      SHOW: 'user_info_show',
      HIDE: 'user_info_hide'
    })

    .constant('PrintixUserInfoSelectors', {
      MODAL_ID: 'infoUserModal',
      CONFIRM_BUTTON_CSS_CLASS: 'confirm-button'
    })

    .controller('InfoUserController', function (
      $rootScope, $scope, $location, URLS, PrintixUserInfoConstants, PrintixUserInfoSelectors,
      TenantListService, $injector, URL_PARAMS) {

      $scope.tenantListService = TenantListService;
      $scope.groupListService = null;

      $scope.user = null;
      $scope.userInfoModalId = PrintixUserInfoSelectors.MODAL_ID;

      try {
        $scope.groupListService = $injector.get('GroupListService');
      } catch (e) {}

      $scope.hasWorkstations = function () {
        return $scope.user?.customProperties.workstationList?.length > 0;
      };

      $scope.hasGroups = function () {
        return TenantListService.currentTenant?.info.groupsEnabled && $scope.user?.info._embedded.groups?.length;
      };

      $scope.goToWorkstationProperties = function (workstation) {
        if (workstation) {
          $location.path(URLS.WORKSTATION_PROPERTIES.replace(URL_PARAMS.WORKSTATION_ID.LOCATION, workstation.customProperties.id));
          $rootScope.$emit(PrintixUserInfoConstants.HIDE);
        } else {
          throw new Error('$scope.goToWorkstationProperties: workstation is missing');
        }
      };

      $scope.clearUserInfo = function () {
        $scope.user = null;
      };

      let deregisterLocationChangeListener = function () {
      };

      $scope.showUserInfo = function (user) {
        if (user) {
          $scope.user = angular.copy(user);
          const userModal = angular.element('#' + $scope.userInfoModalId);
          userModal?.modal('show');
          deregisterLocationChangeListener = $rootScope.$on('$locationChangeStart', function () {
            userModal?.modal('hide');
          });
        } else {
          throw new Error('$scope.showUserInfo: user is missing');
        }
      };

      const deregisterShowUserInfoListener =  $rootScope.$on(PrintixUserInfoConstants.SHOW, function (name, user) {
        $scope.showUserInfo(user);
      });

      $scope.$on('$destroy', function () {
        deregisterShowUserInfoListener();
        deregisterLocationChangeListener();
      });
    })

    .directive('infoUserObjectControl', function ($rootScope, PrintixUserInfoSelectors, PrintixUserInfoConstants) {
      return {
        link: function ($scope, element, attrs) {

          element.on('hide.bs.modal', function () {
            $scope.clearUserInfo(angular.element(document.activeElement).hasClass(PrintixUserInfoSelectors.CONFIRM_BUTTON_CSS_CLASS));
          });

          const deregisterHideUserInfoListener = $rootScope.$on(PrintixUserInfoConstants.HIDE, function () {
            element.modal('hide');
          });

          $scope.$on('$destroy', function () {
            deregisterHideUserInfoListener();
          });

        }
      };
    });

})();
